export const OFFERS_MOCK = [
    {
        "id": "5d5515f2-ad15-4b3f-844d-9468f5594a98",
        "repayment_frequency": {
            "type": "monthly",
            "minimum_installments": 3,
            "maximum_installments": 3,
            "coefficient": 1
        },
        "minimum_amount": "1.0000000000",
        "has_interests": false,
        "has_costs": false
    },
    {
        "id": "fb3fce1e-6549-401a-9609-547c7e8d3861",
        "repayment_frequency": {
            "type": "monthly",
            "minimum_installments": 12,
            "maximum_installments": 12,
            "coefficient": 1
        },
        "minimum_amount": "1.0000000000",
        "has_interests": false,
        "has_costs": false
    },
    {
        "id": "6497f2be-5ea5-45d2-81f0-8f2287ce029a",
        "repayment_frequency": {
            "type": "monthly",
            "minimum_installments": 6,
            "maximum_installments": 6,
            "coefficient": 1
        },
        "minimum_amount": "1.0000000000",
        "has_interests": false,
        "has_costs": false
    }
]